import {
    $,
    $$,
    get,
    show,
    hide,
    getData,
    gtmSimpleEvent,
    Key,
    clickOnEnterKey,
    findClosestMatchingChildWithClass, isVisible
} from '@/Utils';
import {initSearch} from '@/SearchNode';
import {initDropdowns} from '@/sharedComponents/Dropdown/Dropdown';
import {initCustomerService} from '@/sharedComponents/Header/CustomerService';
import {bindCartPanelDeletes, closePanel, fetchAndInsertPartial, openPanel} from '@/sharedComponents/Panel';
import {initSliders} from '@/CustomSlider.js';
import {GtmEventType} from "@/enums";
import {EventDetail} from "@/interfaces";

function getClickedNavElement() {
    const categoryMenu = $("#categoryMenu");
    const clickedPanelTarget = categoryMenu.getAttribute("data-clicked-panel-target");
    if (clickedPanelTarget) {
        const navItem = document.querySelector(`[data-responsive-panel-target=${clickedPanelTarget}]`)
        return navItem as HTMLElement;
    }
}

async function initNavListeners(event : MouseEvent) {
    $$(".sub-menu__container").forEach(container => {
        const childCount = container.childElementCount;
        Array.from(container.children).forEach(e => e.classList.toggle("grow", childCount < 5));
    });
    $$(".sub-menu__mid-level-container").forEach(x => {
        x.addDataBoundEventListener("click", (e: Event) => {
            const activeClass = "sub-menu__block--active";
            const container = (e.currentTarget as HTMLElement).closest(".sub-menu__block");
            const deactivate = container.classList.contains(activeClass);
            $(`.${activeClass}`)?.classList.remove(activeClass);
            if (!deactivate)
                container.classList.add(activeClass);
            if (window.isResponsive)
                container.scrollIntoView({behavior: "smooth"});
        })
    })
    $$(".sub-menu__block-heading").forEach(x => {
        x.addDataBoundEventListener("keydown", (event: KeyboardEvent) => {
            clickOnEnterKey(event, x);
        }, "enter-keypress-bound")
    })
    $$(".responsive-panel__back").forEach(x => {
        x.addDataBoundEventListener("click", closeOverlay);
    })

    $(".main-nav").addEventListener("keydown", (event: KeyboardEvent) => {
        const navItem = (event.target as HTMLElement).closest(".main-nav__item") as HTMLElement;
        if (!navItem) return;

        if (document.activeElement === navItem) {
            clickOnEnterKey(event, navItem);
        }
    });

    function mainNavClickHandler(elem: HTMLElement) {
        return async (event : MouseEvent) => {
            try {
                if ((event.target as Element).matches('.sub-menu__mid-level-container, .responsive-panel, .sub-menu__container') ||
                    (event.target as Element).closest('.sub-menu__mid-level-container, .responsive-panel, .sub-menu__container')) {
                    return;
                }
                event.stopPropagation();
                await toggleHeaderMenu.call(elem);
            } catch (error) {
                console.error('Error in header menu toggle:', error);
            }
        };
    }

    $$(".main-nav__item").forEach(elem => {
   
        elem.addEventListener("click", mainNavClickHandler(elem));
        
        if (!elem.hasAttribute("data-keydown-bound")) {
            elem.addDataBoundEventListener("keydown", (event: KeyboardEvent) => {
                if (document.activeElement === elem) {
                    clickOnEnterKey(event, elem);
                }
            }, "enter-keypress-bound");
            elem.setAttribute("data-keydown-bound", "true");
        }
    });
    // Need to reselect because DOM changed.
    const clickedNavElement = getClickedNavElement();
    await mainNavClickHandler(clickedNavElement)(event);
    // Need to open panel because initial click failed to open panel because panel did not exist yet.
    if (window.isResponsive){
        openPanel(clickedNavElement.getAttribute("data-responsive-panel-target"));
    }
}
async function initHeader() {
    setupMenuLazyLoading();
    document.addEventListener("click", closeOverlay);
    document.addEventListener("keyup", escToClose);
    bindCartPanelDeletes();
    initSliders();
    $(".search").addEventListener("click", toggleResponsiveSearch);
    if (get("Home")) {
        $(".autocomplete__wrapper")?.classList.add("visible");
    }
    focusSkipLinkOnFirstTab();
}


function setupMenuLazyLoading() {

    const categoryMenuWrapper = $("#categoryMenu");
    const categoryMenuHandler = async (event : MouseEvent) => {
        let navItem = (event.target as HTMLElement).closest(".main-nav__item");
        if (!navItem) return;

        const menuLoadingStarted = categoryMenuWrapper.getAttribute("data-clicked-panel-target");
        if (!menuLoadingStarted) {
            categoryMenuWrapper.setAttribute("data-clicked-panel-target", navItem.getAttribute("data-responsive-panel-target"));
            await fetchAndInsertPartial(window.config.getCategoryMenuUrl, "category-menu", "#categoryMenu");
            await initNavListeners(event)
            document.dispatchEvent(new Event("menuLoaded"));

            categoryMenuWrapper.removeEventListener("click", categoryMenuHandler);
        }
    };
    categoryMenuWrapper.addEventListener("click", categoryMenuHandler);
}

function onTabKey(event: KeyboardEvent) {
    if (!event.key) return
    const searchKeyword = get('searchKeyword') as HTMLInputElement;
    const isTab = event.key === Key.Tab
    if (isTab || searchKeyword.value.length > 0) {
        if (isTab) {
            const activeElement = document.activeElement;
            const skipToMain = get('skip-to-main');

            //If during the first tab press focus is on search(site default) or there is no focused element yet, focus on skip to main.
            if ((!searchKeyword || activeElement === searchKeyword) && skipToMain) {
                event.preventDefault();
                skipToMain.focus();
            }
        }
        document.removeEventListener('keydown', onTabKey);
        document.removeEventListener('keyup', onTabKey);
    }
}

function focusSkipLinkOnFirstTab() {
    document.addEventListener('keydown', onTabKey);
    document.addEventListener('keyup', onTabKey);
}


function toggleResponsiveSearch() {
    if (window.isResponsive) {
        $(".autocomplete__wrapper")?.classList.toggle("visible");
        const searchInput = get('searchKeyword') as HTMLInputElement;
        searchInput?.focus();
    }
}

function closeOverlay(event: Event) {
    if ($$("#categoryMenu [aria-expanded='true']").length) {
        if ((event.target as Element).matches('.sub-menu__mid-level-container, .responsive-panel, .sub-menu__container') ||
            (event.target as Element).closest('.sub-menu__mid-level-container, .responsive-panel, .sub-menu__container')) {
            return;
        }
        if (!(event.target instanceof Element) || (!window.isResponsive && (event.target as Element).closest(".main-nav"))) return;
        $$(".main-nav__list [aria-expanded='true']").forEach(elem => {
            elem.setAttribute("aria-expanded", "false")
        });
        hide($(".sub-nav__footer") as HTMLElement);
        $$(".header__overlay.header__overlay--active").forEach(elem => {
            elem.classList.remove("header__overlay--active")
        });
    }
}

async function toggleHeaderMenu(this: HTMLElement) {
    if (this == null) return;
    let closestDiv = this.closest(".nav-item__label");
    closestDiv ??= findClosestMatchingChildWithClass(this, "nav-item__label");
    const isServices = !!this.closest("#servicesMenu")
    if (closestDiv == null) return;
    const footer = $(".sub-nav__footer") as HTMLElement;
    const overlay = $(".header__overlay") as HTMLElement;
    $$(".main-nav__item").forEach(elem => {
        if (this === elem) {
            const expanded = elem.getAttribute("aria-expanded") === "true";
            if (expanded) {
                elem.setAttribute("aria-expanded", "false");
                overlay.classList.remove("header__overlay--active");
                hide(footer);
            } else if(!isServices) {
                elem.setAttribute("aria-expanded", "true");
                if (!window.isResponsive) {
                    overlay.classList.add("header__overlay--active");
                }
                show(footer);
                const activeSubmenu = $("[aria-expanded='true'] .sub-menu") as HTMLElement;
                if (activeSubmenu != null) {
                    footer.style.top = activeSubmenu.clientHeight + "px";
                }
            }
        } else {
            elem.setAttribute("aria-expanded", "false");
        }
    });
    return false
}

function escToClose(event: KeyboardEvent) {
    const panelWrapperActive = $(".panel__wrapper--active");
    if (panelWrapperActive) {
        const panel = $(".panel");
        trapFocus(panel as HTMLElement);

        if (event.key === Key.Escape) {
            closePanel();
        }
    }
    const mainNavActive = $(".main-nav [aria-expanded='true']");
    if (mainNavActive && event.key === Key.Escape) {
        mainNavActive.setAttribute("aria-expanded", "false");
        $(".header__overlay").classList.remove("header__overlay--active");
        hide($(".sub-nav__footer"));
    }
}

function isOnScreen(element: Element) {
    const curTop = element.scrollTop;
    const screenHeight = (window as any).height;
    return !(curTop > screenHeight || curTop === 0);
}

function trapFocus(element: HTMLElement) {
    let firstFocusableEl: HTMLElement;
    let lastFocusableEl: HTMLElement;
    element.querySelectorAll(
        "a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type=\"text\"]:not([disabled]), input[type=\"radio\"]:not([disabled]), input[type=\"checkbox\"]:not([disabled]), select:not([disabled]), h2[tabindex=\"-1\"]")
        .forEach(elem => {
            if (!isOnScreen(elem)) return;
            firstFocusableEl = firstFocusableEl === null ? elem as HTMLElement : firstFocusableEl;
            lastFocusableEl = elem as HTMLElement;
        });

    element.addEventListener("keydown", e => {
        if (e.key !== Key.Tab) {
            return;
        }

        if (e.shiftKey) /* shift + tab */ {
            if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        } else /* tab */ {
            if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        }

    });
}

function initHeaderTabs(initialLoad: boolean) {
    let tab: HTMLElement = null
    if (initialLoad) {
        const selectedMenuId = history.state?.selectedMenuId
        if (selectedMenuId)
            tab = $(`[data-menu-id="${selectedMenuId}"]`)

    }
    if (!tab) {
        const hash = window.location.hash
        if (hash) {
            const elem = $(`[data-hash="${hash}"]`)
            if (elem) {
                closePanel();
                tab = elem
            }
        }
    }
    tab ??= $("[data-header-tab][aria-selected='true']")
    tab?.click()
    activateHeaderTab(tab);

    $$("[data-header-tab]").forEach(x => {
            x.addEventListener("click", () => {
                if (x.hasAttribute("data-tab-url")) {
                    location.href = x.getAttribute("data-tab-url");
                    return;
                }
                activateHeaderTab(x)
            })
            x.addEventListener("keydown", (event: KeyboardEvent) => {
                if (event.key === Key.Enter) {
                    if (x.hasAttribute("data-tab-url")) {
                        location.href = x.getAttribute("data-tab-url");
                        return;
                    }
                    activateHeaderTab(x, true)
                }
            })
        }
    )

    function activateHeaderTab(target: HTMLElement, shiftFocus: boolean = false) {
        if (!target) {
            // Problem - User ends up in a tab that is not visible like /en/news
            // We cannot activate the news tab as it's not there.
            // Solution: We just take the first tab.
            activateHeaderTab(tab ??= $("[data-header-tab]"))
            return;
        }

        const menuId = target.getAttribute("data-menu-id")
        if (menuId) {
            history.replaceState({selectedMenuId: menuId}, '')
            if (shiftFocus) {
                if (menuId === "servicesMenu") {
                    $(`#${menuId} .main-nav__item .nav-item__link`).focus()
                } else {
                    $(`#${menuId} .main-nav__item`).focus()
                }
            }
        }
    }
}

function initHashLinks() {
    $$("[data-hash-link]").forEach(x => x.addEventListener("click", () => {
        window.location.href = x.getAttribute("data-hash-link")
        initHeaderTabs(false)
    }))
}

function initFreeLimit() {
    const freeLimit = get("free-limit");
    if (!freeLimit) {
        return;
    }
    getData(window.config.lhvFreeLimit, x => {
        x.text().then(text => freeLimit.textContent = text);
    }, false);
}

function initLangDropdown() {
    const dd = get("language-selector");
    if (dd) {
        initDropdowns();
        dd.addEventListener("valueChange", (e: CustomEvent<EventDetail>) => {
            const callback = () => {
                window.location.href = e.detail.value
            }
            gtmSimpleEvent(GtmEventType.LanguageChange, e.detail.value, callback);
        });
    }
}

function removePreload() {
    $$(".preload").forEach(x => x.classList.remove("preload"));
}

function initHighlightListener() {
    const elem = get("customer-service-button");
    elem?.addEventListener("click", () => {
        elem.classList.add("highlighted");
    });
}

async function conditionalOpenPanel() {
    const urlParams = new URLSearchParams(window.location.search);
    const loginParams = ["login", "prisijungti"];
    const registerParams = ["register", "registreeri", "registruotis", "registreties", "registratsiya"];
    const contactParams = ["kontakt", "contact", "kontakts", "susisieksumumis"];

    const isLoginPanel = loginParams.some(param => urlParams.has(param));
    const isRegisterPanel = registerParams.some(param => urlParams.has(param));
    const isContactParam = contactParams.some(param => urlParams.has(param));

    if(isContactParam) {
        openPanel("customer-service-panel");
    } else if (!window.currentUser.IsLoggedIn && (isLoginPanel || isRegisterPanel)) {
        if(isRegisterPanel){
            const registerTab = $('[data-tab-id="register-tab"]') as HTMLElement;
            registerTab.classList.add("tabs-menu__item--active");
            const loginTab = $('[data-tab-id="login-tab"]') as HTMLElement;
            loginTab.classList.remove("tabs-menu__item--active");

        }
        await fetchAndInsertPartial(window.config.getSidePanelUrl, "login-panel");
        openPanel("login-panel");
    }
}

const initResponsiveBannerSliders = () => {
    if (window.isResponsive) {
        initSliders()
    }
}

export function headerOnLoad() {
    initSearch()
    initCustomerService()
    initFreeLimit()
    initLangDropdown()
    removePreload()
    initHashLinks()
    window.responsiveObserverFunctions = (window.responsiveObserverFunctions || [])
    window.responsiveObserverFunctions.push(initResponsiveBannerSliders)
}
export function headerOnDomContentLoaded() {
    initHeader()
    initHeaderTabs(true)
    conditionalOpenPanel()
    initHighlightListener()
}

window.addEventListener("load", headerOnLoad)
window.addEventListener("DOMContentLoaded", headerOnDomContentLoaded)